__turbopack_context__.v({
  "btnSubmit": "styles-module__B5eV2G__btnSubmit",
  "form": "styles-module__B5eV2G__form",
  "modalFooter": "styles-module__B5eV2G__modalFooter",
  "modalHeader": "styles-module__B5eV2G__modalHeader",
});
